module.exports = __webpack_public_path__ + "static/media/RecomendaEconomico.ffa99b49.png";